<his-plam [label]="setting().label | hisUi"
          [helptext]="setting().helptext | hisUi"
          [style]="{height: '33vh'}"
          [required]="setting().required"
          [title]="title()">
    <p-editor #content [(ngModel)]="setting().value" [readonly]="setting().readonly" />
</his-plam>
